module.exports = __webpack_public_path__ + "static/media/logout.618b4053.svg";